import { ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import HeroBackground from "./HeroBackground";
import ModernImage from "@/components/ModernImage";
import EN from "@/constants/en";

const Hero = () => {
    return (
        <section id="hero" className="min-h-screen flex items-center justify-center pt-20 relative overflow-hidden">
            {/* Add HeroBackground before content */}
            <HeroBackground />
            <div className="container-custom text-center relative z-20">
                <div className="mx-auto mb-6 h-32 w-32 md:h-40 md:w-40 overflow-hidden rounded-full ring-4 ring-background shadow-lg">
                    <ModernImage
                        src="/uploads/marhaf-portrait.jpg"
                        alt={EN.HERO_NAME}
                        width={160}
                        height={160}
                        className="h-full w-full object-cover object-top"
                        responsive={false}
                        priority
                        fetchPriority="high"
                    />
                </div>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 lcp-optimized">{EN.HERO_NAME}</h1>
                <h2 className="text-xl md:text-2xl font-semibold text-muted-foreground mb-3 lcp-optimized hero-text-optimized">
                    {EN.HERO_ROLE}
                </h2>
                <h3 className="text-base md:text-lg text-muted-foreground mb-6 animate-fade-in" style={{ animationDelay: "0.2s" }}>
                    {EN.HERO_HEADING}
                </h3>
                <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 animate-fade-in" style={{ animationDelay: "0.4s" }}>
                    {EN.HERO_TAGLINE}
                </p>
                <div className="flex flex-wrap justify-center gap-4 mb-12 animate-fade-in" style={{ animationDelay: "0.6s" }}>
                    <Button asChild variant="default" size="lg">
                        <a href="#experience">{EN.HERO_VIEW_EXPERIENCE}</a>
                    </Button>
                    <Button asChild variant="secondary" size="lg">
                        <Link to="/ai">{EN.HERO_VIEW_AI_WORK}</Link>
                    </Button>
                    <Button asChild variant="outline" size="lg">
                        <a href="#contact">{EN.HERO_CONTACT_ME}</a>
                    </Button>
                </div>
                <a href="#about" className="inline-flex items-center justify-center animate-bounce min-h-[48px] min-w-[48px] p-2" aria-label={EN.HERO_SCROLL_LABEL}>
                    <ArrowDown className="h-8 w-8 text-accent" />
                </a>
            </div>
        </section>
    );
};

export default Hero;
